var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestartAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "restart_alt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 8.30249V3.80249L12 9.80249L18 15.8025V11.3025C22.965 11.3025 27 15.3375 27 20.3025C27 24.7575 23.745 28.4475 19.5 29.1675V32.1975C25.425 31.4625 30 26.4225 30 20.3025C30 13.6725 24.63 8.30249 18 8.30249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 20.3025C9 17.8275 10.005 15.5775 11.64 13.9425L9.51 11.8125C7.35 13.9875 6 16.9875 6 20.3025C6 26.4225 10.575 31.4625 16.5 32.1975V29.1675C12.255 28.4475 9 24.7575 9 20.3025Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestartAlt);
export default __webpack_public_path__ + "static/media/restart_alt.4c235ecb2a3b76ad21897663787051de.svg";
export { ForwardRef as ReactComponent };